import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MergeAccountRoutingModule} from './merge-account-routing.module';
import { MergeAccountComponent } from './merge-account.component';
import { MergeAccountFormComponent } from './merge-account-form.component';
import {MergeAccountService} from './merge-account.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AdvanceSearchModule} from '../A2-utils/advance-search/advance-search.module';
import {RiderService} from '../riders/rider.service';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import {InlineSVGModule} from 'ng-inline-svg';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AdvanceSearchModule,
    MergeAccountRoutingModule,
    Trip2ThemeModule,
    InlineSVGModule
  ],
  declarations: [MergeAccountComponent,
    MergeAccountFormComponent],
  exports: [MergeAccountComponent,
    MergeAccountFormComponent],
  providers: [
    MergeAccountService,
  RiderService
  ]
})
export class MergeAccountModule { }



// WEBPACK FOOTER //
// ./src/app/pages/merge-account/merge-account.module.ts